import CryptoJS from 'crypto-js';

// TODO: 请把密钥替换成实际值
const secret = process.env.REACT_APP_SECRET; // 密钥

/**
 * 生成签名
 * @param {Object} config
 * @param {string|Object} [config.body] 请求体（POST 用 body，GET 用 params）
 * @param {string} [config.url] 请求路径（不含域名）
 * @param {string} [config.method] HTTP 方法
 * @param {string} [config.deviceId] 设备 ID
 * @param {number|string} [config.timestamp] 时间戳
 * @returns {{ hashInBase64: string, timestamp: number }}
 */
export function getSign(config) {
  const body =
    config.body == null
      ? ''
      : typeof config.body === 'string'
      ? config.body
      : JSON.stringify(config.body);

  const url = config.url || '';
  const method = (config.method || '').toString();
  const deviceId = config.deviceId || '';
  const timestamp = Number(config.timestamp) || Date.now();

  const key = String(secret || '');
  const str = `${body}${url}${method}${deviceId}${timestamp}`;
  const sign = CryptoJS.HmacSHA256(str, key);
  const hashInBase64 = CryptoJS.enc.Base64.stringify(sign);

  return {
    hashInBase64,
    timestamp,
  };
}

/**
 * 获取/生成设备 ID（会缓存到 localStorage）
 * @returns {string}
 */
export function getDeviceId() {
  try {
    const KEY = 'tt__login__device_id__';
    const hasLocal = typeof localStorage !== 'undefined';
    const saved = hasLocal ? localStorage.getItem(KEY) : null;
    if (saved) return saved;

    let id = '';
    if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
      const arr = new Uint8Array(16);
      crypto.getRandomValues(arr);
      id = Array.from(arr)
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('');
    } else {
      id = Math.random().toString(36).slice(2, 18);
    }

    if (hasLocal) localStorage.setItem(KEY, id);
    return id;
  } catch (e) {
    return Math.random().toString(36).slice(2, 18);
  }
}

/**
 * 示例：在发请求前为 config 添加签名头
 * 这里假设 config 结构类似 axios/fetch 封装的请求配置
 */
export function attachSignToConfig(config) {
  const currentMethod = (config.method || 'get').toString();
  const requestBody =
    currentMethod.toLowerCase() === 'get' ? config.params : config.data;
  const path = config.url || '';
  const deviceId = getDeviceId();

  const { hashInBase64, timestamp } = getSign({
    body: requestBody,
    url: path,
    method: currentMethod.toUpperCase(),
    timestamp: Date.now(),
    deviceId,
  });

  // 这里假设 headers 是一个普通对象，如果你用的是 Headers 实例，请按需调整
  const headers = config.headers || (config.headers = {});
  headers['sign-version'] = '1.0';
  headers['sign'] = hashInBase64;
  headers['timestamp'] = timestamp;
  headers['device-id'] = deviceId;
  headers['device'] = '3';
  headers['lang'] = 'zh';
  headers['app-type'] = 1;
  headers['login-type'] = 2;

  return config;
}


